import { render, staticRenderFns } from "./SearchFilterRemover.vue?vue&type=template&id=4bbe0120"
import script from "./SearchFilterRemover.vue?vue&type=script&lang=ts"
export * from "./SearchFilterRemover.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports